import 'slick-carousel'

// Ensure slick library has been included
if ( typeof $.fn.slick == 'function' ) {

    const $js_slider = $( '.js-slider' );

    $js_slider.slick({
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fal fa-angle-left fa-3x" aria-hidden="true"></i></button></i>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fal fa-angle-right fa-3x" aria-hidden="true"></i></button>'
    });


    $('.js-carousel').slick({
        arrows: false,
        dots: true
    });

    $('.js-products').slick({
        mobileFirst: true,
        arrows: true,
        slidesToShow: 1,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fal fa-angle-left fa-3x" aria-hidden="true"></i></button></i>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fal fa-angle-right fa-3x" aria-hidden="true"></i></button>',
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    centerMode: true,
                    slidesToShow: 3,
                }
            }, {
                breakpoint: 1350,
                settings: {
                    centerMode: true,
                    slidesToShow: 5,
                }
            }
        ]
    })

}
